module.exports = __webpack_public_path__ + "static/media/power-bi.8bb333d7.png";